import { queryClient } from "@/client";
import type { GetDataEnrichmentMatchSuggestionDto } from "@advanced-sales-technologies/backend-client/models/GetDataEnrichmentMatchSuggestionDto";
import { InfiniteData, useMutation } from "@tanstack/react-query";

import { unmatchedItemsQueryKey } from "@/hooks/api/list/enrich/useInfiniteUnmatchedItems";
import useSalesyApiClient from "@/hooks/useSalesyApiClient";

type DiscardUnmatchedMutation = {
  listId: string;
  entryId: string;
  query?: string;
};

export const useDiscardUnmatched = ({ query }: { query: string }) => {
  const { apiClient } = useSalesyApiClient();

  const mutation = useMutation({
    mutationFn: (requestBody: DiscardUnmatchedMutation) =>
      apiClient.listsEnrichment.discardUnmatchedEntry({ id: requestBody.listId, entryId: requestBody.entryId }),
    onSuccess: (_, { listId, entryId }) => {
      queryClient.setQueryData<InfiniteData<GetDataEnrichmentMatchSuggestionDto>>(
        unmatchedItemsQueryKey({ listId, query }),
        (oldData) => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            pages: oldData.pages.map((page) => ({
              ...page,
              data: page.data.filter((item) => item.id !== entryId),
            })),
          };
        },
      );
    },
  });

  const { mutate, ...mutationResult } = mutation;

  return {
    ...mutationResult,
    discardUnmatched: mutate,
  };
};
